import { useEffect, useState } from "react";
import ApiKeyRequests from "../../../../Services/Api/ApiKeyRequests.ts";
import { MdEdit, MdOutlineRefresh } from "react-icons/md";
import ScrollableList from "../../../../Components/ScrollableList/ScrollableList.js";
import AddEditApiKey from "./Components/AddEditApiKey/AddEditApiKey.js";
import HideShowField from "../../../../Components/HideShowField/HideShowField.js";
import ResetKeyModal from "./Components/ResetKeyModal/ResetKeyModal.js";

const ApiSettings = () => {
    const apiKeyRequest = new ApiKeyRequests();
    
    const [apiKeys, setApiKeys] = useState(null);

    const [resetKey, setResetKey] = useState(null);
    const [editKey, setEditKey] = useState(null);
    const [showAdd, setShowAdd] = useState(false);

    

    useEffect(() => {
        refresh();
    }, [])

    const refresh = () => {
        apiKeyRequest.GetAll((data) => {
            const processedData = data.map((apiKey) => {
                return {
                    id: apiKey.id,
                    orginalData: apiKey,
                    text: [
                        apiKey.name
                    ],
                    columns: [
                        <div className="flex gap-24">
                            <div>
                                <p><span className="text-glwhite-600">Name:</span> {apiKey.name}</p>
                                <p className="flex gap-1"><span className="text-glwhite-600">Key:</span> <HideShowField field={apiKey.key}/></p>
                            </div>
                        </div>
                    ]
                }
            });
            
            setApiKeys({processedData : processedData, data : data});
        });
    }


    const remove = (id) => {
        apiKeyRequest.Delete(id, () => {
            refresh();
        });
    }

    return (
        <div className="mt-10">
            <ScrollableList 
                removeFunction={remove}
                setShowAdd={() => {setEditKey(null); setShowAdd(true)}}
                data={apiKeys ? apiKeys.processedData : null}
                customButtons={[
                    { icon: <MdOutlineRefresh title="Restart klucza" size={"22px"} className="iconBtn"/>, onClick: (data) => {setResetKey(data.orginalData)} },
                    { icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => { setEditKey(data.orginalData) } }            
                ]}
                listClass={"overflow-y-auto overflow-x-hidden max-h-[68vh]"}
            />
            { editKey &&
                <AddEditApiKey editData={editKey} hide={() => { setEditKey(null); refresh(); }}/>
            }
            { showAdd &&
                <AddEditApiKey hide={() => { setShowAdd(false); refresh(); }}/>
            }
            { resetKey &&
                <ResetKeyModal apiKey={resetKey} hide={() => {setResetKey(null); refresh();}}/>
            }
        </div>
    )
};

export default ApiSettings;